import styled, { useTheme } from "styled-components";
import Button from "../../components/Button/Button";
import CheckoutEntryCard, {
	EntryCardProps,
} from "../../components/CheckoutEntryCard/CheckoutEntryCard";
import CompanyIcon from "../../assets/placeholders/placeholder.png";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
	StickyCardBody,
	StickyHeaderBar,
	StickyContainer,
} from "../../components/StickyCard/StickyCard";
import RadioField from "../../components/FormFields/RadioField";
import { ListContainer } from "../../components/FormFields/RadioField";
import { useFormik, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import { PaymentProps } from "./Payment";
import { UserPageContainer } from "../../components/UserPageTemplate/UserPageTemplate";
import Icon from "../../components/Icon/Icon";
import { EntryModel } from "../Entries/EntryInterfacesComplete";
import {
	createOrderandPdf,
	getCheckoutEntries,
	getCheckoutEntryCards,
	getDeadlinePrice,
	getFinalPrice,
	priceOrderCheckout,
	removeFromCart,
	submitProject,
} from "./manageCheckout";
import { OrderLineItem, OrderModel, TransactionType } from "./OrderInterfaces";
import { element } from "prop-types";

import { useHistory } from "react-router-dom";
import { useSettings } from "../../hooks/UseSettings";
import { useCompany } from "../../hooks/UseCompany";
import { WarningModal } from "../../components/Modal/Modal";
import HierarchyDropDownModal from "../../components/HierarchyDropDownModal/HierarchyDropDownModal";
import { EntryAction } from "../../components/HierarchyDropDownModal/HierarchyDropDown";
import SubmissionLightbox from "./SubmisisonLightbox";
import { resolveTypeReferenceDirective } from "typescript";
import { CollapsibleContainer } from "../../components/Collapsible/Collapsible";
import { CheckoutEntryCardAlertContext } from "./CheckoutContext";
import config from "../../config";
import assetsConfig from "../../assetsConfig";
import { useAlert } from "../../components/Alert/Alerts";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import { copy } from "../../utils/copy";
import Currency from "../../components/Currency/Currency";
import { ThemisJudgment } from "../Admin/Themis/ThemisInterfaces";
import { Footer } from "../../components/Footer/Footer";

export const OrderSummaryDrawer = styled.div`
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;

	/* margin-bottom: 2rem; */
	background: ${({ theme }) => theme.colorBackgroundLight};
	box-shadow: 0 2px 8px 0 ${({ theme }) => theme.colorBoxShadow};
	z-index: 999;

	.pricing-container {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 2rem;
		padding: 2.25rem 3rem;

		@media only screen and (min-width: ${({ theme }) => theme.lg}) {
			padding: 2.25rem 6rem;
		}
	}
`;

const LoadingSpinner = styled.img`
	width: 11%;
	display: inline-flex;
`;

export const CartTab = () => {
	const theme = useTheme();
	const history = useHistory();
	const { company, setCompany } = useCompany();
	const { addCounter } = useContext(CheckoutEntryCardAlertContext);

	// const orderTitles: any = {};
	const [transactionType, setTransactionType] = useState<TransactionType>(
		TransactionType.Credit,
	);
	const { addNewAlert } = useAlert();

	const [orderTotal, setOrderTotal] = useState<number>(0);
	const [awardGroups, setAwardGroups] = useState<AwardGroups>({});
	const [orderTotalFinal, setOrderTotalFinal] = useState(0);
	const [itemText, setItemText] = useState("");
	const [itemCount, setItemCount] = useState(0);
	const [cartEntries, setCartEntries] = useState<EntryCardProps[]>([]);
	const { settings } = useSelector((state: RootState) => state.settings);
	const [entryChangeModal, setEntryChangeModal] = useState(false);
	const [submissionSubmitting, setSubmissionSubmitting] = useState(false);

	const [judgment, setJudgment] = useState<ThemisJudgment | null>(null);
	const [pricingLoading, setPricingLoading] = useState(false);
	const [pricingError, setPricingError] = useState<string | null>(null);

	// all payments are disabled until payment threshold/override setting is retrieved
	const [isCreditPaymentDisabled, setIsCreditPaymentDisabled] = useState(true);
	const [isCheckPaymentDisabled, setIsCheckPaymentDisabled] = useState(true);
	const [isBankPaymentDisabled, setIsBankPaymentDisabled] = useState(true);
	const [isOfflinePaymentDisabled, setIsOfflinePaymentDisabled] =
		useState(true);

	const [entryIdToDuplicate, setEntryIdToDuplicate] = useState<null | number>(
		null,
	);

	const [order, setOrder] = useState<OrderModel>({
		lineItems: [],
		statusId: 0,
		transactionType: transactionType,
		bankCity: "",
		bankName: "",
		cardInfo: {
			cardCode: "",
			cardNumber: "",
			expirationDate: "",
		},
		notes: "",
		orderTotal: orderTotal,
		discountTotal: 0,
		feeTotal: 0,
		subtotal: 0,
		taxTotal: 0,
		companyAddress1: company.address1 || "",
		companyCity: company.city || "",
		companyCountry: company.country || "",
		companyName: company.name,
		companyPostalCode: company.postalCode || "",
		companyState: company.state || "",
		email: company.financeContactEmail || "",
		phone: company.financeContactPhone || "",
		companyAddress2: company.address2 || "",
		fullName: company.financeContactName || "",
	});

	let countryIso = settings.countryIso;

	const [drawerEl, setDrawerEl] = useState<HTMLElement | null>(null);
	const [drawerHeight, setDrawerHeight] = useState(0);
	const drawerRef = useCallback(
		(node: HTMLElement | null) => setDrawerEl(node),
		[],
	);

	// Reserve scroll space so the fixed drawer never covers content
	useEffect(() => {
		if (!drawerEl) return;

		const updateHeight = () => {
			const newHeight = drawerEl.offsetHeight;
			requestAnimationFrame(() => setDrawerHeight(newHeight));
		};

		const ro = new ResizeObserver(updateHeight);
		ro.observe(drawerEl);
		updateHeight();
		return () => ro.disconnect();
	}, [drawerEl]);

	// function getOrderTotal(type: TransactionType) {
	// 	if (type == TransactionType.Bank) {
	// 		setOrderTotalFinal(orderTotal + 25);
	// 	} else {
	// 		setOrderTotalFinal(orderTotal);
	// 	}
	// 	setTransactionType(type);
	// }

	// useEffect(() => {
	// 	if (transactionType == TransactionType.Bank) {
	// 		setOrderTotalFinal(orderTotal + 25);
	// 	} else {
	// 		setOrderTotalFinal(orderTotal + 0);
	// 	}
	// }, [transactionType, orderTotal]);

	useEffect(() => {
		// Don’t price until we have line items and settings are loaded
		if (!order?.lineItems?.length) return;
		if (!settings || Object.values(settings).length === 0) return;
		if (!countryIso) return;

		let cancelled = false;

		(async () => {
			try {
				setPricingLoading(true);
				setPricingError(null);

				// Important: ensure the order has the latest TransactionType too
				const priced = await priceOrderCheckout({
					...order,
					transactionType,
				});

				if (!cancelled) {
					setJudgment(priced);
					if (priced.total === 0 && order?.lineItems.length >= 1) {
						setTransactionType(TransactionType.Submission);
					}
				}
			} catch (e: any) {
				if (!cancelled) {
					setJudgment(null);
					setPricingError(e?.message || "Unable to calculate pricing.");
				}
			} finally {
				if (!cancelled) setPricingLoading(false);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [
		// inputs that should re-price
		transactionType,
		order.lineItems,
		order.orderTotal,
		order.companyCountry,
		order.companyState,
		countryIso,
		settings,
	]);

	const [cartEntryDescription, setCartEntryDescription] = useState<string>();

	useEffect(() => {
		copy("cartEntryDescription")
			.then((text) => {
				setCartEntryDescription(text);
			})
			.catch();
	}, []);

	useEffect(() => {
		if (judgment && judgment.subtotal) {
			setOrderTotalFinal(judgment.subtotal);
		}
	}, [judgment]);

	async function PostCheckout(CheckoutData: any) {}

	const fieldRequired = "This field is required";
	const formikProps = useFormik({
		initialValues: {
			paymentMethod: "credit-card",
		},
		onSubmit: async (value) => {
			await PostCheckout(value);
			// console.log(value);
		},
		validationSchema: Yup.object({
			award: Yup.string().required(fieldRequired),
		}),
	});

	//   const handleAccordion = (clickedElement: string) => {
	//     const obj: any = {};
	//     Object.entries(entriesCollapsed).forEach(
	//       ([awardName, isCollapsed]) =>
	//         (obj[awardName] = clickedElement === awardName ? !isCollapsed : true)
	//     );
	//     setEntriesCollapsed(obj);
	//   };

	useEffect(() => {
		setOrder((prevOrder) => ({
			...prevOrder,
			companyAddress1: company.address1 || "",
			companyCity: company.city || "",
			companyCountry: company.country || "",
			companyName: company.name,
			companyPostalCode: company.postalCode || "",
			companyState: company.state || "",
			email: company.financeContactEmail || "",
			phone: company.financeContactPhone || "",
			companyAddress2: company.address2 || "",
			fullName: company.financeContactName || "",
		}));
	}, [company]);

	const handleGetCheckoutEntryCards = async (): Promise<EntryCardProps[]> => {
		return getCheckoutEntryCards().then((response) => {
			if (response.status == 200) {
				//console.log("Response: ", response);
				let tempAwardGroups: AwardGroups = {};
				let tempLineItems: LineItem[] = [];
				if (response.data.length === 1) {
					setItemCount(response.data.length);
					if (!settings.featureFlags.Commerce) {
						setItemText(response.data.length + " Project Ready for Submission");
					} else {
						setItemText(response.data.length + " item in your cart");
					}
				} else {
					setItemCount(response.data.length);
					if (!settings.featureFlags.Commerce) {
						setItemText(
							response.data.length + " Projects Ready for Submission",
						);
					} else {
						setItemText(response.data.length + " items in your cart");
					}
				}
				setCartEntries(response.data);
				let orderLineItems: OrderLineItem[] = [];
				response.data.forEach((entry: EntryCardProps) => {
					let lineItem: LineItem = {
						awardName: entry.award!,
						entry: entry,
					};
					let orderLineItem: OrderLineItem = {
						entryId: entry.id,
						entry: entry,
					};
					orderLineItems.push(orderLineItem);

					tempLineItems.push(lineItem);
				});
				setOrder((order) => {
					return {
						...order,
						lineItems: orderLineItems,
					};
				});
				const groups: AwardGroups = tempLineItems.reduce((groups, lineItem) => {
					const group = groups[lineItem.awardName] || [];
					group.push(lineItem);
					groups[lineItem.awardName] = group;
					return groups;
				}, tempAwardGroups);
				setAwardGroups(groups);

				// else {
				//   formikProps.setFieldValue("paymentMethod", "");
				//   setTransactionType(TransactionType.Unassigned);
				// }

				// reutrn cart entries
				return response.data;
			} else return [];
		});
	};

	// check each entry to ensure they're valid
	const checkValidEntries = (entries: EntryCardProps[]): boolean => {
		let isValid = true;

		entries.forEach((entry) => {
			if (!entry.isValid) isValid = false;
		});

		return isValid;
	};

	const goToCheckout = async (
		entries: EntryCardProps[],
		orderTotalFinal: number,
	) => {
		let closedEntries: boolean = false;
		entries.map((entry) => {
			if (entry.programEntriesClosed) {
				removeFromCart(entry.id).catch((e) => {
					if (!settings.featureFlags.Commerce) {
						addNewAlert({
							type: "error",
							message: "Unable to send to drafts",
						});
					} else {
						addNewAlert({
							type: "error",
							message: "Unable to remove from cart",
						});
					}
				});
				closedEntries = true;
			}
		});

		if (!closedEntries) {
			if (!settings.featureFlags.Commerce) {
				entries.map((entry) => {
					submitProject(entry.id).catch((e) => {
						addNewAlert({
							type: "error",
							message: "Unable to submit",
						});
					});
				});
			} else if (orderTotalFinal === 0) {
				setSubmissionSubmitting(true);
				let updatedOrder = {
					...order,
					transactionType: TransactionType.Submission,
				};

				setOrder(updatedOrder);

				try {
					// show confirmation modal once pdf is created
					const processedOrder = await createOrderandPdf(
						updatedOrder,
						countryIso,
						company.taxID,
						settings.featureFlags["Invoice Notes"] || false,
					);

					// console.log("AAAAAAAAAAA createOrderandPdf", processedOrder);
					processedOrder.paymentDate = new Date(processedOrder.paymentDate);
					// console.log("processedOrder.data", processedOrder.data);

					if (!processedOrder.data.isError) {
						setOrder(processedOrder.data);
						setSubmissionSubmitting(false);
					} else {
						addNewAlert({
							type: "error",
							message: processedOrder.data.authMessage,
						});
					}
					// order.data.isError === false
					// 	? setOrder(order.data.order)
					// 	: setErrors(order.data.authMessage);
				} catch (err) {
					addNewAlert({ type: "error", message: String(err) });
					setSubmissionSubmitting(false);
				}
			} else {
				history.push({
					pathname: `/payment/${TransactionType[transactionType]}`,
					state: { orderTotalFinal: orderTotalFinal },
				});
			}
		} else {
			setEntryChangeModal(true);
		}
	};
	useEffect(() => {
		if (!company?.id) return; // wait for company to load
		handleGetCheckoutEntryCards();
	}, [entryChangeModal, settings, company]);

	// toggles payment options depending on total order price and payment threshold
	useEffect(() => {
		// wait for company & settings to load
		if (company && settings && Object.values(settings).length > 0) {
			// credit card payment is always available
			setIsCreditPaymentDisabled(false);

			if (company.blockDelayedPayments) {
				setIsBankPaymentDisabled(true);
				setIsCheckPaymentDisabled(true);
				setIsOfflinePaymentDisabled(true);
			} else if (!settings.paymentThreshold || company.overridePaymentMethod) {
				setIsBankPaymentDisabled(false);
				setIsCheckPaymentDisabled(false);
				setIsOfflinePaymentDisabled(false);
			} else {
				if (orderTotalFinal < settings.paymentThreshold) {
					formikProps.setFieldValue("paymentMethod", "credit-card");
					setIsBankPaymentDisabled(true);
					setIsCheckPaymentDisabled(true);
					setIsOfflinePaymentDisabled(true);
				} else {
					//   formikProps.setFieldValue("paymentMethod", "");
					setIsBankPaymentDisabled(false);
					setIsCheckPaymentDisabled(false);
					setIsOfflinePaymentDisabled(false);
				}
			}
		}
	}, [orderTotalFinal, settings, company]);

	// update user menu counters
	useEffect(() => {
		addCounter();
	}, [awardGroups]);

	// set default transaction type based on featureFlag
	useEffect(() => {
		if (settings.featureFlags.Paymentz) {
			setTransactionType(TransactionType.Paymentz);
			setIsCreditPaymentDisabled(true);
			setIsBankPaymentDisabled(true);
			setIsCheckPaymentDisabled(true);
			setIsOfflinePaymentDisabled(false);
		}
	}, [settings]);

	return (
		<UserPageContainer className="flex-1">
			<div style={{ paddingBottom: drawerHeight }}>
				<WarningModal
					show={entryChangeModal}
					title="Entry Change"
					message="Some entries in your cart cannot be submitted because entries are closed. They have been removed from your cart. Please reach out if you believe this is an error using the Help button below."
					close={() => setEntryChangeModal(false)}
				>
					<Button
						className="w-[225px]"
						onClick={() => setEntryChangeModal(false)}
						icon="check"
					>
						OK
					</Button>
				</WarningModal>
				{order.id && <SubmissionLightbox order={order} show={order !== null} />}
				<HierarchyDropDownModal
					entryId={entryIdToDuplicate}
					setEntryId={setEntryIdToDuplicate}
					action={EntryAction.Duplicate}
				/>
				<FormikProvider value={formikProps}>
					<h2>
						{!settings.featureFlags.Commerce ? "Ready to Submit" : "My Cart"}
					</h2>
					{cartEntryDescription && (
						<p
							className="mb-[3rem] mt-[1rem]"
							dangerouslySetInnerHTML={{ __html: cartEntryDescription }}
						/>
					)}

					<OrderSummaryDrawer ref={drawerRef}>
						<div className="pricing-container">
							<div className="flex flex-col gap-[1rem]">
								<h2>
									{!settings.featureFlags.Commerce
										? "Ready to Submit"
										: "My Cart"}
								</h2>
								<p>{itemText}</p>
							</div>
							<div className="flex flex-wrap gap-[3rem]">
								{orderTotalFinal !== 0 && !settings.featureFlags.Paymentz && (
									<ListContainer rows={3} cols={1} name="paymentMethod">
										<RadioField
											name="paymentMethod"
											label="Credit Card Payment"
											value="credit-card"
											onClick={() => setTransactionType(TransactionType.Credit)}
											disabled={isCreditPaymentDisabled}
										/>
										<RadioField
											name="paymentMethod"
											label="Check Payment"
											value="check"
											onClick={() => setTransactionType(TransactionType.Check)}
											disabled={isCheckPaymentDisabled}
										/>
										<RadioField
											name="paymentMethod"
											label="Bank Transfer + $25.00 Fee"
											value="bank"
											onClick={() => setTransactionType(TransactionType.Bank)}
											disabled={isBankPaymentDisabled}
										/>
									</ListContainer>
								)}
								{orderTotalFinal !== 0 && settings.featureFlags.Paymentz && (
									<ListContainer rows={2} cols={1} name="paymentMethod">
										<RadioField
											name="paymentMethod"
											label="Online Payment"
											value="credit-card"
											onClick={() =>
												setTransactionType(TransactionType.Paymentz)
											}
										/>
										<RadioField
											name="paymentMethod"
											label="Offline Payment"
											value="offline"
											onClick={() =>
												setTransactionType(TransactionType.Offline)
											}
											disabled={isOfflinePaymentDisabled}
										/>
									</ListContainer>
								)}

								<div className="flex flex-col mt-auto gap-[1rem]">
									{pricingLoading && (
										<div className="text-sm opacity-70">Calculating taxes…</div>
									)}

									{pricingError && (
										<div className="text-sm text-red-500">{pricingError}</div>
									)}
									{orderTotalFinal !== 0 && (
										<h2 className="whitespace-nowrap">
											Order Subtotal:{" "}
											<b>
												<Currency
													countryIso={countryIso}
													amount={orderTotalFinal}
												/>
											</b>
										</h2>
									)}
									<Button
										disabled={
											(itemCount === 0 &&
												transactionType !== TransactionType.Submission) ||
											submissionSubmitting
										}
										icon={submissionSubmitting ? "" : "caret"}
										iconRight={true}
										iconRotation="-90deg"
										iconColor={
											itemCount !== 0 ? theme.colorCopyLightLight : undefined
										}
										onClick={async () => {
											// fetch cart entries again to ensure they're up to date
											const cartEntries = await handleGetCheckoutEntryCards();

											if (cartEntries.length > 0) {
												const validEntries = checkValidEntries(cartEntries);

												// check for valid entries
												if (validEntries) {
													if (!settings.featureFlags.Commerce) {
														goToCheckout(cartEntries, orderTotalFinal).then(
															() => {
																history.push("/entries/entries-search");
															},
														);
													} else {
														goToCheckout(cartEntries, orderTotalFinal);
													}
												} else {
													addNewAlert({
														type: "error",
														message:
															"Some entries in your cart are invalid. Please review them before proceeding.",
													});
												}
											}
										}}
										// to={`/payment/${TransactionType[transactionType]}`}
									>
										{submissionSubmitting ? (
											<LoadingSpinner src={config.assets.loading.primary} />
										) : orderTotalFinal !== 0 ? (
											"Proceed to Payment"
										) : !settings.featureFlags.Commerce ? (
											"Submit Projects"
										) : (
											"Submit Entries"
										)}
									</Button>
								</div>
							</div>
						</div>

						<Footer className="border-t border-gray-200" />
					</OrderSummaryDrawer>

					<StickyContainer className="!min-h-0" maxH={1000 * 3000 + "px"}>
						{Object.entries(awardGroups).flatMap(
							([awardName, lineItems], i) => {
								if (lineItems !== null && lineItems.length > 0) {
									return (
										<CollapsibleContainer
											key={i}
											className="mb-[2rem]"
											title={awardName}
											//   isCollapsed={entriesCollapsed[awardName]}
											//   onClickCollapse={() => handleAccordion(awardName)}
										>
											<StickyCardBody
												//   key={i}
												className="flex flex-col gap-[1.875rem]"
											>
												{lineItems.map((lineItem) => (
													<CheckoutEntryCard
														key={lineItem.entry.id}
														entry={lineItem.entry}
														awardName={lineItem.awardName}
														showRemoveCartButton={true}
														setEntryIdToDuplicate={setEntryIdToDuplicate}
														onRemove={() => {
															// wait for entry cards to update before showing alert
															handleGetCheckoutEntryCards().then(() => {
																if (!settings.featureFlags.Commerce) {
																	addNewAlert({
																		type: "success",
																		message: "Successfully sent to drafts",
																	});
																} else {
																	addNewAlert({
																		type: "success",
																		message: "Successfully removed from cart",
																	});
																}
															});
														}}
													/>
												))}
											</StickyCardBody>
										</CollapsibleContainer>
									);
								}
							},
						)}
					</StickyContainer>
				</FormikProvider>
			</div>
		</UserPageContainer>
	);
};

export default CartTab;

interface AwardGroups {
	[key: string]: LineItem[];
}

interface LineItem {
	awardName: string;
	entry: EntryCardProps;
}
